



import { Component, Prop, Provide, Vue } from 'vue-property-decorator'
import { getFullText } from '@/service/platform'
@Component
export default class DocPreview extends Vue {
  public fullText = ''
  public get instanceId() {
    return String(this.$route.query._id) || ''
  }
  public mounted() {
    this.getFullTextReq()
  }
  public async getFullTextReq() {
    // console.log(1)
    try {
      let { data, success } = await getFullText({ instance_id: this.instanceId })
      if (success) {
        this.fullText = data.full_text
      } else {
        this.fullText = ''
      }
    } catch (e) {
      this.fullText = ''
    }
  }
}
